import { CommonStorage } from "../_services/storage";

import {
    getGlobalField
} from "@/_store/helpers";

const DataGridState = {
    isAvailable(key) {
        if (CommonStorage.getItems(key)) return true;
        // if (localStorage.getItem(key)) return true;
        else return false;
    },

    // async readStoredState(key, dbResponse) {

    //     let cashResponse = JSON.parse(
    //         CommonStorage.getItems(key)
    //     );

    //     if (cashResponse.searchText) CommonStorage.saveItems('searchText', cashResponse.searchText);

    //     dbResponse.columns.forEach((db) => {
    //         cashResponse.columns.forEach((store) => {
    //             // console.log('X1 ', getGlobalField(db.screenField));
    //             if (store.dataField == db.screenField || store.dataField == db.gridDataField || (store.dataField == getGlobalField(db.screenField).dataField || store.dataField == getGlobalField(db.screenField).gridDataField)) {
    //                 if (store.hasOwnProperty("groupIndex")) {
    //                     db.groupIndex = store.groupIndex;
    //                 } else db.groupIndex = undefined;
    //                 if (store.hasOwnProperty("visibleIndex")) {
    //                     db.visibleIndex = store.visibleIndex;
    //                 } else db.visibleIndex = undefined;
    //                 if (store.hasOwnProperty("sortOrder")) {
    //                     db.sortOrder = store.sortOrder;
    //                 } else db.sortOrder = undefined;
    //                 if (store.hasOwnProperty("sortIndex")) {
    //                     db.sortIndex = store.sortIndex;
    //                 } else db.sortIndex = undefined;
    //                 if (store.hasOwnProperty("visible")) {
    //                     db.visible = store.visible;
    //                 } else db.visible = false;

    //                 if (store.dataField == 'ProductDescription1') console.log('++++ ', db);
    //             } else {
    //                 // db.groupIndex = db.visibleIndex = db.sortOrder = db.sortIndex = undefined;
    //             }
    //         });

    //         var dataField = db.screenField

    //         if (db.gridDataField) dataField = db.gridDataField;
    //         else if (getGlobalField(db.screenField).gridDataField) dataField = getGlobalField(db.screenField).gridDataField;
    //         else if (getGlobalField(db.screenField).dataField) dataField = getGlobalField(db.screenField).dataField;
    //         else dataField = db.screenField;


    //         var label = db.screenField;

    //         if (db.gridLabel) label = db.gridLabel;
    //         else if (getGlobalField(db.screenField).gridLabel) label = getGlobalField(db.screenField).gridLabel;
    //         else if (getGlobalField(db.screenField).label) label = getGlobalField(db.screenField).label;




    //         // console.log('XX ', db.screenField , dataField , cashResponse.columns.findIndex((x) => x.dataField == dataField));
    //         console.log('XX ', db.screenField, dataField, label);

    //         if (db.screenField == 'Product') {
    //             cashResponse.columns.forEach(element => {
    //                 if (element.dataField == dataField) {
    //                     console.log('S1 ', element, db);
    //                 }
    //             });
    //         }


    //         if (
    //             CommonStorage.getItems("filter-panel-" + key) !== null
    //         ) {
    //             let filtercashResponse = JSON.parse(
    //                 CommonStorage.getItems("filter-panel-" + key)
    //             );

    //             if (db.hasOwnProperty("filterDefaultValue")) {
    //                 db.filterDefaultValue = new Array();
    //             }
    //             filtercashResponse.forEach((filterstore) => {
    //                 if (filterstore != "and") {
    //                     filterstore.forEach((filterstore1) => {
    //                         console.log('X2 ', filterstore1[0], getGlobalField(db.screenField));
    //                         if (filterstore1[0] == db.screenField || filterstore1[0] == db.filterDataField || filterstore1[0] == getGlobalField(db.screenField).dataField) {

    //                             // console.log('A1', filterstore1[2])

    //                             if (filterstore1[2].toString().match(/^[+-]?\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])/) == null) {
    //                                 if (db.filterDefaultValue === undefined) {
    //                                     db.filterDefaultValue = new Array(filterstore1[2]);
    //                                 } else {
    //                                     db.filterDefaultValue.push(filterstore1[2]);
    //                                 }
    //                             } else {

    //                                 console.log('XXX ', db.filterDefaultValue);

    //                                 if (filterstore1[1] == '>=' && filterstore.length == 3) {

    //                                     if ((new Date(filterstore[2][2]) - new Date(filterstore[0][2])) / (1000 * 60 * 60 * 24) == 1) {
    //                                         db.filterDefaultValue = new Date(filterstore1[2]).addGMTHours(0, 0);
    //                                         db.filterOperator = "=";
    //                                     } else {
    //                                         db.filterDefaultValue = { from: new Date(filterstore[0][2]), to: new Date(filterstore[2][2].replace('Z', '')) }
    //                                         db.filterOperator = "between";
    //                                     }

    //                                 } else if (filterstore1[1] == '<' && filterstore.length == 1) {
    //                                     db.filterOperator = "<";

    //                                     db.filterDefaultValue = new Date(filterstore1[2]);
    //                                 } else if (filterstore1[1] == '>' && filterstore.length == 1) {
    //                                     db.filterOperator = ">";

    //                                     db.filterDefaultValue = new Date(filterstore1[2]);
    //                                 } else if (filterstore1[1] == '<=' && filterstore.length == 1) {
    //                                     db.filterOperator = "<=";

    //                                     db.filterDefaultValue = new Date(filterstore1[2]);
    //                                 }
    //                                 else if (filterstore1[1] == '>=' && filterstore.length == 1) {
    //                                     db.filterOperator = ">=";

    //                                     db.filterDefaultValue = new Date(filterstore1[2]);
    //                                 } //else db.filterDefaultValue = undefined;
    //                             }
    //                         }
    //                     });
    //                 }
    //             });
    //         }
    //     });

    //     dbResponse.columns.sort(function (a, b) {
    //         return a.visibleIndex - b.visibleIndex;
    //     });

    //     return dbResponse;
    // },

    getColumns(key, dbResponse) {
        let cashResponse = JSON.parse(CommonStorage.getItems(key));
        // if (cashResponse.searchText) CommonStorage.saveItems('searchText', cashResponse.searchText);

        dbResponse.forEach(db => {
            var index = cashResponse.columns.findIndex((x) => x.dataField == db.dataField && x.name == db.caption);

            if (index > -1) {
                var store = cashResponse.columns[index];
                if (store.hasOwnProperty("groupIndex")) {
                    db.groupIndex = store.groupIndex;
                } else db.groupIndex = undefined;
                if (store.hasOwnProperty("visibleIndex")) {
                    db.visibleIndex = store.visibleIndex;
                } else db.visibleIndex = undefined;
                if (store.hasOwnProperty("sortOrder")) {
                    db.sortOrder = store.sortOrder;
                } else db.sortOrder = undefined;
                if (store.hasOwnProperty("sortIndex")) {
                    db.sortIndex = store.sortIndex;
                } else db.sortIndex = undefined;
                if (store.hasOwnProperty("visible")) {
                    db.visible = store.visible;
                } else db.visible = false;

            }

        });

        dbResponse.sort(function (a, b) {
            return a.visibleIndex - b.visibleIndex;
        });

        return dbResponse;
    },
    setSearchText(key) {

        if (!CommonStorage.getItems(key)) return true;
        else {
            let cashResponse = JSON.parse(CommonStorage.getItems(key));
            if (cashResponse.searchText) {
                CommonStorage.saveItems('searchText', cashResponse.searchText);
            } else CommonStorage.clear('searchText');
        }
    },
    setFilterData(key, items) {
        if (!CommonStorage.getItems(key)) return items;
        else {
            if (CommonStorage.getItems("filter-panel-" + key) !== null) {
                let filtercashResponse = JSON.parse(CommonStorage.getItems("filter-panel-" + key));

                items.forEach(db => {
                    if (db.hasOwnProperty("filterDefaultValue")) {
                        db.filterDefaultValue = new Array();
                    }
                    filtercashResponse.forEach((filterstore) => {
                        if (filterstore != "and") {
                            filterstore.forEach((filterstore1) => {
                                if (filterstore1[0] == db.screenField || filterstore1[0] == db.filterDataField || filterstore1[0] == getGlobalField(db.screenField).dataField) {
                                    // if (filterstore1[0] == db.dataField) {

                                    if (filterstore1[2].toString().match(/^[+-]?\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])/) == null) {

                                        if (db.type == 'Integer' || db.type == 'Text') {
                                            db.filterDefaultValue = null;
                                        }
                                        else if (db.filterDefaultValue === undefined) {
                                            db.filterDefaultValue = new Array();
                                        }
                                        if (filterstore1[1] == '<' || filterstore1[1] == '>' || filterstore1[1] == '<=' || filterstore1[1] == '>=') {
                                            if (filterstore.length == 3) {
                                                db.filterDefaultValue = { from: filterstore[0][2], to: filterstore[2][2] }
                                                db.filterOperator = "between";
                                            } else {
                                                db.filterOperator = filterstore1[1];
                                                db.filterDefaultValue = filterstore1[2];
                                            }
                                        } else {
                                            if (Array.isArray(db.filterDefaultValue))
                                                db.filterDefaultValue.push(filterstore1[2]);
                                            else db.filterDefaultValue = filterstore1[2];


                                            if (filterstore1[1] == '=' || filterstore1[1] == 'startswith' || filterstore1[1] == 'contains' || filterstore1[1] == 'endswith') {
                                                db.filterOperator = filterstore1[1];
                                            }

                                        }
                                    } else {
                                        if (filterstore1[1] == '>=' && filterstore.length == 3) {

                                            if ((new Date(filterstore[2][2]) - new Date(filterstore[0][2])) / (1000 * 60 * 60 * 24) == 1) {
                                                db.filterDefaultValue = new Date(filterstore1[2]).addGMTHours(0, 0);
                                                db.filterOperator = "=";
                                            } else {
                                                db.filterDefaultValue = { from: new Date(filterstore[0][2]), to: new Date(filterstore[2][2].replace('Z', '')) }
                                                db.filterOperator = "between";
                                            }

                                        } else if (filterstore1[1] == '<' && filterstore.length == 1) {
                                            db.filterOperator = "<";

                                            db.filterDefaultValue = new Date(filterstore1[2]);
                                        } else if (filterstore1[1] == '>' && filterstore.length == 1) {
                                            db.filterOperator = ">";

                                            db.filterDefaultValue = new Date(filterstore1[2]);
                                        } else if (filterstore1[1] == '<=' && filterstore.length == 1) {
                                            db.filterOperator = "<=";

                                            db.filterDefaultValue = new Date(filterstore1[2]);
                                        }
                                        else if (filterstore1[1] == '>=' && filterstore.length == 1) {
                                            db.filterOperator = ">=";

                                            db.filterDefaultValue = new Date(filterstore1[2]);
                                        } // else db.filterDefaultValue = undefined;
                                    }
                                }
                            });
                        }
                    });

                    if (db.hasOwnProperty("filterDefaultValue") && db.filterDefaultValue.length == 0) db.filterDefaultValue = undefined;

                });

            }
            return items;
        }
    },
    getSearchText() {
        return CommonStorage.getItems('searchText');
    }


}


export { DataGridState };